export enum Steps {
  locationStep = 'locationStep',
  dateStep = 'dateStep',
  personStep = 'personStep',
  careStep = 'careStep',
  detailStep = 'detailStep',
  outSessionStep = 'outSessionStep',
  sessionStep = 'sessionStep',
}

export const orderedSteps = [
  Steps.locationStep,
  Steps.dateStep,
  Steps.personStep,
  Steps.careStep,
  Steps.detailStep,
  Steps.outSessionStep,
  Steps.sessionStep,
]

export interface RecommendationForm {
  care: boolean
  location: boolean
  person: boolean
  date: boolean
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/RecommendationForm/RecommendationForm.model.ts